import { render } from "./KubernetesServiceTab.vue?vue&type=template&id=86a3c39a&scoped=true"
import script from "./KubernetesServiceTab.vue?vue&type=script&lang=js"
export * from "./KubernetesServiceTab.vue?vue&type=script&lang=js"

import "./KubernetesServiceTab.vue?vue&type=style&index=0&id=86a3c39a&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-deb-pkg-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-86a3c39a"]])

export default __exports__